export function waitForUserGeo() {
  return new Promise(resolve => {
    // If already available, return immediately
    if (window.XO && window.XO.userGeo) {
      resolve(window.XO.userGeo);
    } else {
      // Wait for the event
      document.addEventListener('userGeoReady', e => resolve(e.detail), {
        once: true,
      });
      // Safety timeout (2 seconds)
      setTimeout(() => resolve({is_eu: false}), 2000);
    }
  });
}
